import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Input, List, Spinner } from "reactstrap";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { headerDropdownIcon } from "../SvgIcons";
import { fetchCountryList } from "../../../store/actions";

const countryOptions = [
    { label: 'IN (+91)', value: 'India' },
    { label: 'US (+1)', value: 'US' },
]
// ui-cmd-5
const DmPhoneNumberInput = ({ countryCode, phoneNum, name, onInputChange, error, placeholder, ...props }) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredItems, setFilterdItems] = useState([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const inputRef = useRef(null);
    const dispatch = useDispatch();
    const CountryState = useSelector(state => state.Account?.country)
    const { loading, list: countryList } = CountryState


    useEffect(() => {
        if (isDropdownOpen && countryList?.length === 0) {
            dispatch(fetchCountryList())
        }
    }, [isDropdownOpen])

    useEffect(() => {
        setFilterdItems(countryList)
    }, [countryList])

    useEffect(() => {
        const filteredItems = countryList.filter((item) =>
            item?.label?.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilterdItems(filteredItems)
    }, [searchTerm])
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };



    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen)
        setSearchTerm("")
    }


    const handleCountryChange = (e, option) => {
        if (onInputChange)
            onInputChange({
                phNum: phoneNum, cCode: option.value, dialCode: option.dialCode
            }, name, e)
    }
    return (
        <div>
            <div className="dm-phone-input" >
                <Dropdown
                    isOpen={isDropdownOpen}
                    toggle={() => {
                        if (!isDropdownOpen) {
                            inputRef?.current?.focus();
                        }
                        toggleDropdown()
                    }}
                    direction="down"
                    className="custom-dropdown dropdown"

                >

                    <DropdownToggle tag="span" className="toggle-button dropdown-text" >
                        <input
                            type="text"
                            value={searchTerm}
                            onChange={handleSearchChange}
                            placeholder={filteredItems.find(obj => obj.value === countryCode)?.label || countryOptions[0]?.label}
                            ref={inputRef}
                            className="toggle-input"
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                }
                            }}
                            readOnly={!isDropdownOpen}

                        />

                        <div className="dropdown-icon">{headerDropdownIcon}</div>
                        <div className="vertical-line" />


                    </DropdownToggle>
                    <DropdownMenu
                        className={`custom-dropdown-menu ${loading ? "make-center" : ""}`}
                    >

                        {
                            loading ?
                                < div>
                                    <Spinner color="primary" size="sm" />
                                </div>
                                :
                                filteredItems?.length === 0 ?
                                    <DropdownItem>No Options</DropdownItem>
                                    :
                                    filteredItems?.map((option) => (
                                        <DropdownItem
                                            className={`dropdown-item ${(option.value === countryCode.value) ? "selected" : ""}`}
                                            key={option.label}
                                            onClick={(e) => {
                                                setTimeout(() => {
                                                    setSearchTerm("")
                                                    handleCountryChange(e, option);
                                                }, 1);
                                            }}
                                        >
                                            {option.label}
                                        </DropdownItem>
                                    ))}
                    </DropdownMenu>
                </Dropdown>
                <Input
                    type="text"
                    onChange={(e) => {
                        let phValue = e.target.value
                        const testRegex = /^[0-9]*$/
                        if (testRegex.test(phValue)) {
                            if (onInputChange) onInputChange({ cCode: countryCode, phNum: phValue }, name, e)

                        }
                    }}
                    value={phoneNum}
                    placeholder={placeholder}
                    name={name}
                    {...props}
                />

            </div>
            {error && <p className="invalid-feedback">{error}</p>}
        </div>
    );

}

export default DmPhoneNumberInput;